import React from 'react'
import { ConnectWallet } from './ConnectWallet'
import { useDispatch, useSelector } from 'react-redux'
import { fetchUpdateProfile, updateTheme as updateThemeUnlogin } from '../redux/slices/UserSlice';
import { Link } from 'react-router-dom';
import logoImg from '../images/logo.png';
import { useAccount } from 'wagmi';
import VerifyModal from './VerifyModal';

export default function Header() {
    const theme = useSelector((state) => state.user.theme);
    const { address , isConnected } = useAccount();
    const dispatch = useDispatch()
    const isLogin = useSelector(state => state.user.isLogin);

    const updateTheme = () => {
        if (address) {
            dispatch(fetchUpdateProfile({ update: { theme: theme === 'dark' ? 'light' : 'dark' }, address: address }))
        }
        else {
            dispatch(updateThemeUnlogin())
        }
    }

    return (
        <>
            <header class={`${theme === 'dark' ? '' : 'header-light scroll-light'} transparent`}>
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="de-flex sm-pt10">
                                <div class="de-flex-col">
                                    <div class="de-flex-col">

                                        <div id="logo">
                                            <Link to="/">
                                                <img alt="logo" class="logo" src={logoImg} />
                                                <img alt="logo" class="logo-2" src={logoImg} />
                                            </Link>
                                        </div>

                                    </div>
                                </div>
                                <div class="de-flex-col header-col-mid">

                                    <ul id="mainmenu">
                                        <li>
                                            <Link to="/">Home<span></span></Link>
                                        </li>
                                        <li>
                                            <a href="#sec">Explore<span></span></a>
                                            <ul>
                                                <li>
                                                    <Link to="/explore-nfts">Marketplace</Link>
                                                </li>
                                                <li>
                                                    <Link to="/collections">Collections</Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <Link to="/">Create<span></span></Link>
                                            <ul>
                                                <li>
                                                    <Link to="/create-nft">NFTs</Link>
                                                </li>
                                                <li>
                                                    <Link to="/create-collection/options">Collection</Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <a href="#sec">Profile<span></span></a>

                                            <ul>
                                                <li>
                                                    <Link to="/profile">Settings</Link>
                                                </li>
                                                <li>
                                                    <Link to="/my-profile">My Profile</Link>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <div class="menu_side_area">
                                        <ConnectWallet />
                                        <span onClick={() => updateTheme()} id="switch_scheme">
                                            {theme === 'light' ? (
                                                <i class="ss_dark fa fa-moon-o"></i>
                                            ) : (
                                                <i class="ss_light fa fa-sun-o"></i>
                                            )}
                                        </span>
                                        <span id="menu-btn"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            {!isLogin && address && isConnected &&
                <VerifyModal />
            }
        </>
    )
}
